<template>
  <div class="tooltip-warp">
    <div ref="tooltip" v-if="!isTooltip">{{ tooltipText }}</div>
    <el-tooltip class="tooltip" :style="'width:' + (width - 30) + 'px'" effect="dark" popper-class="tableTypePopperClass" placement="bottom" v-if="isTooltip">
      <div slot="content" :style="'width:' + (width + 20) + 'px'">
        {{ tooltipText }}
      </div>
      <div ref="tooltip">{{ tooltipText }}</div>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isTooltip: false,
    };
  },
  props: {
    tooltipText: {
      default: "",
      type: String,
    },
    width: {
      default: 200,
      type: Number,
    },
  },
  watch: {
    tooltipText: {
      handler() {
        this.$nextTick(() => {
          let clientWidth = this.$refs.tooltip.clientWidth - (this.width - 22);
          this.isTooltip = clientWidth > 0 ? true : false;
        });
      },
      deep: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      let clientWidth = this.$refs.tooltip.clientWidth - (this.width - 22);
      this.isTooltip = clientWidth > 0 ? true : false;
    });
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.tooltip-warp {
  display: flex;
  align-items: center;
  justify-content: center;
  .tooltip {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
<style>
.tableTypePopperClass.is-dark {
  background: rgba(21, 28, 38, 0.7) !important;
}
.tableTypePopperClass[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: rgba(21, 28, 38, 0.2) !important;
}
.tableTypePopperClass[x-placement^="bottom"] .popper__arrow:after {
  border-bottom-color: rgba(21, 28, 38, 0.6) !important;
}

.tableTypePopperClass[x-placement^="top"] .popper__arrow {
  border-top-color: rgba(21, 28, 38, 0.2) !important;
}
.tableTypePopperClass[x-placement^="top"] .popper__arrow:after {
  border-top-color: rgba(21, 28, 38, 0.6) !important;
}
</style>
